import type { Competency, Service } from '../types/executive'

export const competencies: Competency[] = [
  {
    title: 'Multi-State Operational Oversight',
    description:
      'Regional expansion and business-unit leadership across California and Nevada offices, including staffing, market entry, and full P&L accountability.',
    tags: ['CA & NV Offices', 'Regional Expansion'],
  },
  {
    title: 'Mega-Project & Capital Delivery',
    description:
      'Executive oversight of programs at scale: $460M LAX terminal cores, $410M Kaiser Permanente LAMC, $250M Nevada healthcare, $225M San Bernardino courthouse.',
    tags: ['$460M LAX', '$410M Kaiser LAMC'],
  },
  {
    title: 'P&L Financial Turnaround - From Deficit to Sustained Profitability',
    description:
      'Reengineered underperforming business units to achieve sustained profitability, including a significant multi-million-dollar earnings improvement.',
    tags: ['Business-Unit Turnaround', 'Cost Controls'],
  },
  {
    title: 'Advanced Alternative Delivery',
    description:
      'Design-Build, CMAR, and Lean IPD structures with GMP assembly, teaming agreements, and risk-balanced prime negotiation.',
    tags: ['Design-Build', 'CMAR', 'Lean IPD'],
  },
  {
    title: 'Regulatory Compliance Mastery',
    description:
      'Strict HCAI / OSHPD healthcare workflows, California seismic compliance, and phased construction on fully operational hospital campuses.',
    tags: ['HCAI / OSHPD', 'Seismic Compliance'],
  },
]

export const services: Service[] = [
  {
    number: '01',
    title: 'Strategic Capital Project Advisory',
    summary:
      'Owner-side counsel from capital master planning through preconstruction, aligning program scope, budget, and schedule before commitments harden.',
    scope: [
      'Institutional & higher education programs',
      'Healthcare capital planning under HCAI/OSHPD',
      'Preconstruction strategy & GMP assembly',
    ],
  },
  {
    number: '02',
    title: 'Board Governance & JV Steering',
    summary:
      'Independent governance support for boards and joint ventures carrying multi-party delivery risk on high-capital programs.',
    scope: [
      'Multi-party risk mitigation frameworks',
      'Audit, controls & reporting cadence',
      'Steering-committee facilitation',
    ],
  },
  {
    number: '03',
    title: 'Enterprise Risk & Delivery Models',
    summary:
      'Selection and structuring of the delivery model that fits the program, with the contractual controls to hold it together in execution.',
    scope: [
      'Design-Build, CMAR & Lean IPD structuring',
      'Teaming agreements & prime negotiation',
      'Claims avoidance & recovery planning',
    ],
  },
]

export const skills: string[] = [
  'Board Governance',
  'Executive P&L Leadership',
  'HCAI / OSHPD Compliance',
  'Capital Master Planning',
  'Design-Build & CMAR',
  'Joint-Venture Steering',
  'Turnaround Management',
  'Lean IPD',
  'GMP Assembly',
  'Preconstruction Strategy',
  'Aviation & Healthcare Delivery',
  'Multi-State Operations',
]
